import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { EventsRoutingModule } from './events-routing.module'
import { RouterModule } from '@angular/router'
import { EventHubDataService } from './services/event-hub-data.service'
import { ScheduleModule } from '../schedule/schedule.module'
import { EmptyTab } from './components/event-detail/event-tabs/empty-tab/empty-tab.component'
import { EventHubSmartComponent } from '../event-hub/event-hub-smart.component'
import { EntityHubLayoutModule } from '../libs/_layouts/entity-hub-layout/entity-hub-layout.module'
import { ErrorModule } from '../libs/error/error.module'

@NgModule({
  imports: [CommonModule, RouterModule, EventsRoutingModule, ErrorModule, ScheduleModule, EntityHubLayoutModule],
  exports: [EventHubSmartComponent],
  declarations: [EmptyTab, EventHubSmartComponent],
  providers: [EventHubDataService]
})
export class EventsModule {}
